import { GoalModel } from '@models/goals';
import { GoalSubscriptionModel } from '@models/goalSubscriptions';
import { GoalPackageModel } from '@models/orders';

export interface PackageBucket {
  pkg: GoalPackageModel;
  goals: GoalModel[];
}

export interface SplitGoalsByPackagesResult {
  subscriptionsOutsidePackages: GoalSubscriptionModel[];
  enrollableGoalsOutsidePackages: GoalModel[];
  packageBuckets: PackageBucket[];
}

export interface SplitGoalsByPackagesInput {
  goalSubscriptions: GoalSubscriptionModel[];
  enrollableGoals: GoalModel[];
  packages: GoalPackageModel[];
}

export function splitGoalsByPackages(
  data: SplitGoalsByPackagesInput,
  showPackages: boolean
): SplitGoalsByPackagesResult {
  const { goalSubscriptions, enrollableGoals, packages } = data;

  if (!showPackages) {
    return {
      subscriptionsOutsidePackages: goalSubscriptions,
      enrollableGoalsOutsidePackages: enrollableGoals,
      packageBuckets: []
    };
  }

  const packagedGoalIds = new Set(packages.flatMap((p) => p.goalEntityIds));
  const subByGoalEntityId = new Map(goalSubscriptions.map((s) => [s.goal.entityId, s]));
  const enrollByGoalEntityId = new Map(enrollableGoals.map((g) => [g.entityId, g]));

  return {
    subscriptionsOutsidePackages: goalSubscriptions.filter(
      (s) => !packagedGoalIds.has(s.goal.entityId)
    ),
    enrollableGoalsOutsidePackages: enrollableGoals.filter((g) => !packagedGoalIds.has(g.entityId)),
    packageBuckets: packages
      .map((pkg) => {
        const goals: GoalModel[] = [];
        for (const goalEntityId of pkg.goalEntityIds) {
          const sub = subByGoalEntityId.get(goalEntityId);
          if (sub) {
            goals.push({ ...sub.goal, subscription: sub });
            continue;
          }
          const enrollableGoal = enrollByGoalEntityId.get(goalEntityId);
          if (enrollableGoal) {
            goals.push(enrollableGoal);
          }
        }
        return { pkg, goals };
      })
      .filter((b) => b.goals.length > 0)
  };
}
